import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { ActivatedRoute } from '@angular/router'
import { Router } from '@angular/router'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { AuthorizeService } from '../../service/authorize.service'
import { MatMenuTrigger } from '@angular/material'
import { ToastrService } from '../../../../node_modules/ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-business-description-executive-summary',
  templateUrl: './business-description-executive-summary.component.html',
  styleUrls: ['./business-description-executive-summary.component.scss']
})
export class BusinessDescriptionExecutiveSummaryComponent implements OnInit {
  @ViewChild('templateSaved') templateSaved: TemplateRef<any>
  modalRef: BsModalRef
  modalConfig: {
    animated: true
    keyboard: true
    backdrop: true
    ignoreBackdropClick: true
  }

  @Input() exesumTrigger
  @Input() pdf: any
  @Input() print: any
  @Input() printPage
  @Input() isFullFactSheet
  updatedBy
  asOfDate
  text
  newText
  checkDis = false
  checkModified = false
  comId
  businessEng
  newbusinessEng
  isBusinessHeader = true
  checkUpdate = false
  file: File
  subscription: Subscription
  symbol
  isAE
  remark = 'Remark: ข้อมูลที่ปรับปรุงจะถูกเผยแพร่บน SETSMART ในวันทำการถัดไป'
  message
  constructor(
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private store: StoreService,
    private authorization: AuthorizeService,
    private toastr: ToastrService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.isAE = response['ae']
        this.symbol = response['securitySymbol']
        this.text = response['businessTypeThai']
        this.businessEng = response['businessTypeEng']
        this.comId = response['companyIdPsims']
        this.updatedBy = response['businessTypeUpdateBy']
        this.asOfDate = response['businessTypeAsOfDate']
        this.onChangeData()
      })
  }

  get isUserHasPermission(): Boolean {
    return (
      this.authorization.hasRole('COMPINFO_EDIT')
    )
  }

  async onChangeData() {
    this.newText = this.text
    this.newbusinessEng = this.businessEng
  }

  modifiedText() {
    return (this.checkModified = true)
  }
  checkDisplay() {
    return (this.checkDis = true)
  }

  checkCancel() {
    this.newText = this.text
    this.newbusinessEng = this.businessEng
    return (this.checkUpdate = false), (this.checkDis = false)
  }

  checkSubmit() {
    this.text = this.newText
    this.businessEng = this.newbusinessEng
    this.updateToSecprofileThai()
    this.updateToSecprofileEng()
    return (this.checkUpdate = true), (this.checkDis = false)
  }

  async updateToSecprofileThai() {
    const body = {
      companyId: this.comId,
      fieldName: 'businessTypeThai',
      fieldValue: this.newText
    }
    await this.cpmService.updateCompanyProfile(body).then(response => {
      if (response.status === 'FAIL') {
        alert('' + response.message)
      }
    })
  }

  async updateToSecprofileEng() {
    const body = {
      companyId: this.comId,
      fieldName: 'businessTypeEng',
      fieldValue: this.newbusinessEng
    }
    await this.cpmService.updateCompanyProfile(body).then(response => {
      this.message = response.status
      this.message === 'OK' ? (this.toastr.success('การบันทึกรายการสำเร็จแล้ว')) : (this.message = 'บันทึกรายการไม่สำเร็จ')
    },
    error => {
      this.message = 'บันทึกรายการไม่สำเร็จ'
      this.openModal(this.templateSaved)
    })
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, this.modalConfig, { class: 'modal-sm' })
    )
  }
  closeModal() {
    this.modalRef.hide()
  }
  clickEditDropdown(event: Event) {
    $(event.target)
      .closest('div')
      .next()
      .toggleClass('show')
  }

  mourseLeaveMenu() {
    $(event.target)
      .find('#editItemListBusiness')
      .removeClass('show')
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/business-description-executive-summary/business-description-executive-summary.component.ts